import type React from "react";
import { useEffect } from "react";

import type { ServicePartnerPageDetailsDto } from "@/api/types";
import { useSlug } from "@/hooks/useSlug";
import { useConfig } from "@/providers/config/useConfig";
import { servicePartnerMutations } from "@/queries/service-partners/mutations";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

import { IntegrationAccessButton } from "../IntegrationAccessButton";
import { ServiceDetailsBlockCard } from "../ServiceDetailsBlockCard";

interface MyPupDetailsViewProps {
  serviceDetails: ServicePartnerPageDetailsDto;
}

export function MyPupDetailsView({ serviceDetails }: MyPupDetailsViewProps): React.ReactNode {
  const slug = useSlug();
  const { t } = useTranslation();
  const dashboardRootUrl = useConfig("newDashboardRootUrl");

  const registerMyPupMutation = servicePartnerMutations.useRegisterMyPup();
  const partnerProperties = serviceDetails.partnerProperties.myPup!;

  useEffect(() => {
    const url = new URL(window.location.href);
    const myPupLoginUrl = url.searchParams.get("com_return_url");

    if (myPupLoginUrl) {
      if (!partnerProperties?.isRegistered) {
        registerMyPupMutation.mutate();
      }
      window.open(myPupLoginUrl, "_self");
    }
  }, [partnerProperties?.isRegistered, registerMyPupMutation]);

  const returnUrl = dashboardRootUrl
    ? `${dashboardRootUrl}${routes.servicePartners.details({ slug, id: serviceDetails.id })}`
    : undefined;

  return (
    <ServiceDetailsBlockCard title={t("page.service-details.mypup.title")}>
      <IntegrationAccessButton
        servicePartnerId={serviceDetails.id}
        label={t("page.service-details.mypup.access")}
        returnUrl={returnUrl}
      />
    </ServiceDetailsBlockCard>
  );
}
